export const APP_VERSION = 'e4dfb02-1793706551936'
